import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EnvironmentService } from '../services';

@Injectable()
export class ApiInterceptor implements HttpInterceptor {
    private envService = inject(EnvironmentService);

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        request = request.clone({
            setHeaders: this.getHeaders(request)
        });
        return next.handle(request);
    }

    private getHeaders(request: HttpRequest<any>): any {
        const headers: { [key: string]: string } = {
            Accept: 'application/json',
            'Content-Type': 'application/json; charset=utf-8',
            'X-APPLICATION-API-KEY': this.envService.apiKey
        };

        return headers;
    }
}
